// extracted by mini-css-extract-plugin
module.exports = {"outlined":"SelectButton_outlined__SW2um","solid":"SelectButton_solid__1fmLh"};